import React, { useState } from 'react';
import { AppointmentTitle } from './AppointmentTitle';
import { AppointmentHeaderInformation } from './AppointmentHeaderInformation';
import { AppointmentTabsContainer } from './Tabs/AppointmentTabsContainer';
import { RescheduleContainer } from './RescheduleContainer';
import { AppointmentProgressions } from './AppointmentProgressions';
import { useSelectAppointmentFromPathParam } from '../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { SchedulingCard } from '../Reusable/SchedulingCard';
import { UUID } from 'types/shared/UUID';
import { EditAppointment } from '../EditAppointment/EditAppointment';

export interface IAppointmentContainerProps {
  onAddEventClick: (appointmentId?: UUID) => void;
  onClose: () => void;
}

export const AppointmentContainer: React.FC<IAppointmentContainerProps> = ({ onClose, onAddEventClick }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const [showEdit, setShowEdit] = useState(false);
  const onEditClick = () => {
    setShowEdit(true);
  };
  const onCloseEditForm = () => {
    setShowEdit(false);
  };

  if (!appointmentFromPath) return null;

  return (
    <SchedulingCard title={<AppointmentTitle onClose={onClose} />}>
      <RescheduleContainer />
      {showEdit ? (
        <EditAppointment onCloseEditForm={onCloseEditForm} />
      ) : (
        <>
          {appointmentFromPath.isSignatureSyncAppointment && <AppointmentProgressions />}
          <div className={'flex flex-col gap-2'}>
            <AppointmentHeaderInformation onEditClick={onEditClick} />
            <AppointmentTabsContainer onAddEventClick={onAddEventClick} />
          </div>
        </>
      )}
    </SchedulingCard>
  );
};
